import React, { useEffect, useState } from 'react';

import { 
  CharacterSheetInterface,
} from "@dndModels";
import CommonUtilities from "@utilities/common_utilities";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import FlexBox from '@components/layout/FlexBox';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { CHARACTER_LEVELS } from '@dndModels/Constants';

interface Props {
  char: CharacterSheetInterface;
  disabled?: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterAttunementCustomizations({ 
  char,
  disabled = false,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [override_max, setOverrideMax] = useState(char.customizations.overrides.attunement_slots);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="row" className="padded">
      <FlexBox xs_expand={0} className="centered" style={{ width: "33%" }} direction="column">
        <FlexBox xs_expand={0} className="header">
          Override Attunement Slots: 
        </FlexBox>
        <FlexBox xs_expand={0} className="small_label gray">
          Currently { char.mind.max_attuned_items }
        </FlexBox>
      </FlexBox>
      <FlexBox>
        <SelectStringBox 
          name=""
          value={ override_max === undefined ? "Don't Override" : `${override_max}` } 
          options={["Don't Override",...CHARACTER_LEVELS]}
          disabled={ disabled }
          onChange={ async (changed: string) => {
            if (changed === "Don't Override") {
              delete char.customizations.overrides.attunement_slots;
              setOverrideMax(undefined);
            } else {
              const attunement_slots = +changed;
              char.customizations.overrides.attunement_slots = attunement_slots;
              setOverrideMax(attunement_slots);
            }
            char.changed();
            char.subscription_holder.recalculate();
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
